import { Shark, SmartModel, Utils } from "shark-mvc";

//Qui importiamo moment che è la libreria predefinta (e preferita da Shark) per gestire date e tempi.
//Essendo un modulo di Node, non serve indicare un percorso ma basta il nome del modulo come lo si è installato.
import moment from "moment";

class Refuel extends SmartModel {
	constructor(data) {
		super();
		
		this.amount = 0;
		this.datetime = "0000-00-00 00:00:00";
		this.driverId = "";
		this.fullRefuel = true;
		this.km = 0;
		this.qt = 0;
		this.vehicleId = "";
		this.vendor = "FCF";

		this.__errorCount = 0;
		this.__errors = [];
		this.__fullRefuelString = "true";
		this.__showRefuelFields = false;
		this.__vehicleName = "";

		if (data) {
			this.import(data);
		}
	}

	export(options) {
		const exportedData = this.__export();

		exportedData.datetime = this.datetime.format("YYYY-MM-DD HH:mm:ss");

		return exportedData;
	}

	onDataChanged(data){
		console.log({data});

		switch (data.property) {
			case "__fullRefuelString":
				this.fullRefuel = data.newValue === "true";
				this.__showRefuelFields = true;
				// Shark.render();
				break;
			case "__vehicleName":
				const vehicleList = Shark.get("vehicleList");
				const vehicle = Utils.safp(vehicleList, "name", this.__vehicleName);
	
				const vehicleField = document.querySelector("#vehicleField");

				if (vehicleField) {
					if (!vehicle) {
						vehicleField.classList.add("is-invalid");
						vehicleField.classList.remove("is-valid");
					}
					else {
						this.vehicleId = vehicle.id;
						vehicleField.classList.add("is-valid");
						vehicleField.classList.remove("is-invalid");
					}
				}
				break;
		}
	}

	// import (data, options) {
		// if (data.createdAt !== "0000-00-00 00:00:00") {
		// 	data.createdAt = moment.utc(data.createdAt).local();//moment(data.createdAt).tz("Europe/Rome").format("YYYY-MM-DD HH:mm:ss");
		// }
	// }

	validate () {
		this.__errorCount = 0;
		this.__errors = [];

		if (this.amount === 0) {
			this.__errorCount++;
			this.__errors.push({
				code: "amount",
				label: "L'importo non è valido"
			});
		}

		if (this.km === 0) {
			this.__errorCount++;
			this.__errors.push({
				code: "km",
				label: "I chilometri non sono validi"
			});
		}

		if (this.qt === 0) {
			this.__errorCount++;
			this.__errors.push({
				code: "qt",
				label: "La quantità non è valida"
			});
		}

		if (this.__vehicleName === "") {
			this.__errorCount++;
			this.__errors.push({
				code: "vehicle",
				label: "Devi indicare un mezzo"
			});
		}
		else {
			const vehicleList = Shark.get("vehicleList");
			const vehicle = Utils.safp(vehicleList, "name", this.__vehicleName);

			if (!vehicle) {
				this.__errorCount++;
				this.__errors.push({
					code: "vehicle",
					label: "Il mezzo indicato non esiste"
				});
			}
		}

		return this.__errorCount === 0;
	}
};

Shark.registerModel("Refuel", Refuel);